var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7097 14.3404L7.16174 3.41852C7.0613 3.28794 6.90393 3.21428 6.73987 3.21428H4.1517C3.92737 3.21428 3.80349 3.47209 3.94076 3.6462L12.8269 15L3.94076 26.3538C3.90985 26.3933 3.89067 26.4406 3.88541 26.4905C3.88015 26.5404 3.88903 26.5907 3.91104 26.6358C3.93304 26.6808 3.96728 26.7188 4.00984 26.7453C4.0524 26.7718 4.10156 26.7858 4.1517 26.7857H6.73987C6.90393 26.7857 7.0613 26.7087 7.16174 26.5815L15.7097 15.6629C16.0144 15.2712 16.0144 14.7288 15.7097 14.3404ZM25.8883 14.3404L17.3403 3.41852C17.2399 3.28794 17.0825 3.21428 16.9184 3.21428H14.3303C14.1059 3.21428 13.9821 3.47209 14.1193 3.6462L23.0055 15L14.1193 26.3538C14.0884 26.3933 14.0692 26.4406 14.064 26.4905C14.0587 26.5404 14.0676 26.5907 14.0896 26.6358C14.1116 26.6808 14.1459 26.7188 14.1884 26.7453C14.231 26.7718 14.2801 26.7858 14.3303 26.7857H16.9184C17.0825 26.7857 17.2399 26.7087 17.3403 26.5815L25.8883 15.6629C26.193 15.2712 26.193 14.7288 25.8883 14.3404Z",
    fill: "#0885C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdaIcon);
export default __webpack_public_path__ + "static/media/ida-icon.fb9ce8d5e44ea38682b7a3920e8cf948.svg";
export { ForwardRef as ReactComponent };